module.exports = __webpack_public_path__ + "static/media/complex-app.436ac1fb.png";